import $ from "jquery";
import axios from "axios";
import {AD_CLICK, AD_RENDER, AD_VIEW, BOOKMAKER_CLICK, BOOKMAKER_VIEW} from "Core/links";
import {getCurrentPageNumber} from "../materials/getCurrentPageNumber";
import {isMobile} from "Core/screenSizes";
import {CHANGE_CONTENT, dispatchEvent} from '../../../common/events';

const BRANDING_WITH_OUT_SELF_HEIGHT = 'brandingWithOutSelfHeight';

const viewedAd = [];
const ADS_COUNTER = 'adsCounter';
const SESSION_KEY = 'sessionTime';
const SESSION_TIME = 60 * 60;
const viewedBookmaker = [];

const waitingForContentAdList = [];
const DELAY_FOR_WAIT_ADS = 1000;
const DELAY_FOR_STOP_WAIT = 15000;
const startTime = new Date().getTime();

export const generalHandlersAfterLoad = () => {
    $('.banner-placeholder').each(function () {
        const elementData = $(this).data();
        axios.get(AD_RENDER, {
            params: {
                place: elementData['place'],
                isGroup: elementData['isGroup'],
                isCenter: $('.material-content__part.material-content__part--centered').length > 0,
                mapViews: getAdsMapByPlace(elementData['place']),
                exceptedIdList: getExceptedAdsIdBySessionPlace(elementData['place']),
            }
        })
            .then((response) => {
                let str = changeYandexRtb(response.data);
                str = changeAdFox(str);
                str = changeParentBlock(str);
                $(this).replaceWith(str);

                adViewAndClickHandlers();

                brandings();

                changeSectionPaddingTop();

                dispatchEvent(CHANGE_CONTENT, {});

                if ($('#tabs-schedule').length > 0) {
                    window.scrollTo(0, $('#tabs-schedule').offset().top);
                }

                if ($('#tabs-medals').length > 0) {
                    window.scrollTo(0, $('#tabs-medals').offset().top);
                }

                dispatchEvent(CHANGE_CONTENT, {});
            });
    });

    adViewAndClickHandlers();

    $('.clickable-link').each(function () {
        if ($(this).next().is('.match-predictions__center')) {
            $(this).css('bottom', `${$(this).next().height() + 11}px`)
        }
    });

    bookmakerViewAndClickHandlers();
};

export const adViewAndClickHandlers = () => {
    $('.ad-content:visible').each(function () {
        console.info('Try to view', $(this).data());

        if (isEmptyAdFoxBlock($(this))) {
            waitingForContentAdList.push($(this));
        } else {
            adAddHandlersViewAndClick($(this));
        }
    });
};

export const bookmakerViewAndClickHandlers = () => {
    const bookmaker = $('.match-predictions__center:first:visible');

    if (bookmaker !== undefined && bookmaker.length > 0) {
        if (viewedBookmaker.indexOf(bookmaker.data('id')) !== -1) {
            return;
        }

        viewedBookmaker.push(bookmaker.data('id'));
        axios.post(BOOKMAKER_VIEW, {bookmakerId: bookmaker.data('id')});
    }

    $('.match-predictions__row').each(function () {
        if (viewedBookmaker.indexOf($(this).data('id')) !== -1) {
            return;
        }

        viewedBookmaker.push($(this).data('id'));
        axios.post(BOOKMAKER_VIEW, {bookmakerId: $(this).data('id')});
    });

    $('.match-predictions__center:visible, .match-predictions__row').each(function () {
        $(this).click(function () {
            const bookmakerId = $(this).data('id');

            axios.post(BOOKMAKER_CLICK, {bookmakerId: bookmakerId});
        });
    });
};

export const getAdsMapByPlace = (place) => {
    const storage = window.localStorage;
    const currentDate = (new Date()).toDateString().replace(/\s+/g, '').toLowerCase();

    let adsCounter = JSON.parse(storage.getItem(ADS_COUNTER));

    if (adsCounter === null) {
        adsCounter = {};
    }

    if (adsCounter[place] === undefined) {
        adsCounter[place] = {};
        storage.setItem(ADS_COUNTER, JSON.stringify(adsCounter));

        return [];
    }

    const map = {};

    for (const id in adsCounter[place]) {
        if (adsCounter[place][id][currentDate] !== undefined) {
            map[id] = adsCounter[place][id][currentDate];
        }
    }

    return map;
};

export const getExceptedAdsIdBySessionPlace = (place) => {
    const storage = window.localStorage;

    let adsCounter = JSON.parse(storage.getItem(ADS_COUNTER));

    if (adsCounter === null) {
        adsCounter = {};
    }

    if (adsCounter[place] === undefined) {
        adsCounter[place] = {};
        storage.setItem(ADS_COUNTER, JSON.stringify(adsCounter));

        return [];
    }

    const time = Math.ceil((new Date()).getTime() / 1000);

    const list = [];

    for (const id in adsCounter[place]) {
        if (
            adsCounter[place][id][SESSION_KEY] !== undefined
            &&
            adsCounter[place][id][SESSION_KEY] >= time - SESSION_TIME
        ) {
            list.push(id);
        }
    }

    return list;
};

// let timerId = setInterval(() => {
//     if (new Date().getTime() - startTime > DELAY_FOR_STOP_WAIT && waitingForContentAdList.length === 0) {
//         console.info('Stop wait ads');
//         clearInterval(timerId);
//
//         return;
//     }
//
//     for (const i in waitingForContentAdList) {
//         if (!isEmptyAdFoxBlock(waitingForContentAdList[i])) {
//             adAddHandlersViewAndClick(waitingForContentAdList[i]);
//
//             waitingForContentAdList.splice(i, 1);
//         }
//     }
// }, DELAY_FOR_WAIT_ADS);

const isEmptyAdFoxBlock = (ad) => {
    return false;

    if (ad.find('[id^="adfox"]').length === 0) {
        return false;
    }

    return ad.find('[id^="adfox"]:first').height() === 0;
};

const adAddHandlersViewAndClick = (ad) => {
    const elementData = ad.data();

    if (viewedAd.indexOf(elementData['id']) !== -1) {
        return;
    }

    console.info('Send view handler', elementData);

    incrementCounter(elementData['place'], elementData['id']);

    viewedAd.push(elementData['id']);
    axios.get(AD_VIEW, {params: {adId: elementData['id']}});

    ad.click(function () {
        const adId = elementData['id'];

        axios.get(AD_CLICK, {params: {adId: adId}});
    });
};

const changeYandexRtb = (str) => {
    const result = str.match(/(yandex_rtb.+?)('|\\")/);

    if (result === null || result[1] === undefined) {
        return str;
    }

    const currentPageNumber = getCurrentPageNumber();

    str = str.replaceAll(result[1], `${result[1]}-${currentPageNumber}`);
    str = str.replaceAll('pageNumber: 0', `pageNumber: ${currentPageNumber}`);

    return str;
};

export const changeAdFox = (str) => {
    if (str.length === 0 || str.indexOf('adfox_') === -1) {
        return str;
    }
    let newStr = str.replace(/\s/gm, ' ');

    let result = newStr.match(/(data-id="(\d+)").*(data-is-without-block="(0|1)").*?>.*?(params:.*?(}))/);

    if (result !== null && result[4] === '0' && result[5] !== undefined) {
        newStr = newStr.replace(result[5], `${result[5]},onLoad: function(data) {adsFoxOnLoad(${result[2]})}, onError: function(error) {adsFoxOnError(error, ${result[2]})}, onStub: function() {adsFoxOnStub(${result[2]})}`);
    }

    result = newStr.match(/(adfox_\d+)/);

    if (result === null || result[1] === undefined) {
        return newStr;
    }

    const currentPageNumber = getCurrentPageNumber();

    newStr = newStr.replaceAll(result[1], `${result[1]}-${currentPageNumber}`);

    return newStr;
};

export const changeParentBlock = (str) => {
    if (str.indexOf('data-is-without-block="') === -1) {
        return str;
    }

    let newStr = str.replace(/\s/gm, ' ');

    let regex = /(<.*(data-is-without-block="(0|1)").*?>)/gm;

    let resultDiv = regex.exec(newStr);

    let countDivOpenTag = (resultDiv[1].match(/<div/g) || []).length;
    regex = new RegExp(`(<.*?(data-is-without-block="(0|1)").*?>)(.*?<\/script>.*)((<\\/div>.*){${countDivOpenTag}})`, 'gm');

    let result = regex.exec(newStr);

    if (result !== null && result[3] === '1') {
        newStr = newStr.replace(result[1], '').replace(result[5], '');
    }

    return newStr


    // const element = $('.ad-content[data-place="' + place + '"]');
    //
    // if (element.data('isWithoutBlock') === 1) {
    //
    //     if (element.parents('#modal-block').length > 0) {
    //         $('body').append(element.html())
    //         element.parents('#modal-block').remove();
    //
    //         return;
    //     }
    //
    //     if (element.parents('#catfish-modal').length > 0) {
    //         element.parents('#catfish-modal').replaceWith(element.html());
    //
    //         return;
    //     }
    //
    //     if (element.parents('.banner-wrapper').length > 0) {
    //         element.parents('.banner-wrapper').replaceWith(element.html());
    //
    //         return;
    //     }
    //
    //     element.replaceWith(element.html());
    // }
}

const changeSectionPaddingTop = () => {
    $('.banner-spacer').css('height', $('#wrapper__header .banner-wrapper:visible').height() + 'px');
};

export const brandings = (force = false) => {
    if (!force && ($('.branding div[id^="BrandingDesktopFormat"]').length > 0 || $('div[id^="adfox"]').length > 0)) {
        return;
    }

    if (isMobile()) {
        $('.wrapper__content-inner').css('background-color', 'transparent');

        return;
    }

    let timerId = setInterval(() => {
        if ($('.branding #adv-link').length > 0) {
            $('.branding #adv-link').css('top', `${$('.wrapper__header').height()}px`);
            $('.branding #adv-link').data('startTop', $('.wrapper__header').height());

            clearInterval(timerId);
        }
    }, 10);

    $('.branding .ad-content').each(function () {
        if (!$(this).is(`.${BRANDING_WITH_OUT_SELF_HEIGHT}`)) {
            $('.wrapper__content-inner').css('paddingTop', `${$(this).height()}px`);
            $(this).height($('body').height() - $('.wrapper__header').height());
            $(this).addClass(BRANDING_WITH_OUT_SELF_HEIGHT);
        }
    });

    $('.wrapper__content-inner .plate-list').css('background-color', 'white');
    $('.page-content-wrapper.page-content-wrapper--column .material-content-breadcrumbs.fixable-div--hide-on-mobile.fixable-div').css('background-color', 'white');
};

const incrementCounter = (place, id) => {
    const storage = window.localStorage;
    const currentDate = (new Date()).toDateString().replace(/\s+/g, '').toLowerCase();

    let adsCounter = JSON.parse(storage.getItem(ADS_COUNTER));

    if (adsCounter === null) {
        adsCounter = {};
    }
    if (adsCounter[place] === undefined) {
        adsCounter[place] = {};
    }

    if (adsCounter[place][id] === undefined) {
        adsCounter[place][id] = {};
    }

    const time = Math.ceil((new Date()).getTime() / 1000);

    if (adsCounter[place][id][SESSION_KEY] === undefined) {
        adsCounter[place][id][SESSION_KEY] = time;
    }

    if (adsCounter[place][id][SESSION_KEY] <= time - SESSION_TIME) {
        adsCounter[place][id][SESSION_KEY] = time;
    }

    if (adsCounter[place][id][currentDate] === undefined) {
        adsCounter[place][id][currentDate] = 0;
    }

    adsCounter[place][id][currentDate] = ++adsCounter[place][id][currentDate];

    storage.setItem(ADS_COUNTER, JSON.stringify(adsCounter));
};

window.adsFoxOnLoad = (id) => {
    console.info(`ADFOX ONLOAD ${id}`);

    const block = $('.ad-content[data-id="' + id + '"]');

    block.parents('#catfish-block').show();
    block.parents('#catfish-modal').show();
    block.parents('#ad-popup').show();

    adAddHandlersViewAndClick(block);

    dispatchEvent(CHANGE_CONTENT, {});
};

window.adsFoxOnError = (error, id) => {
    console.info(`ADFOX error ${id}`, error);
    deleteAdBlock(id);
};

window.adsFoxOnStub = (id) => {
    console.info(`ADFOX STUB ${id}`);
    deleteAdBlock(id);

};

const deleteAdBlock = (id) => {
    const block = $('.ad-content[data-id="' + id + '"]');

    if (block.parents('.banner-wrapper').length > 0) {
        block.parents('.banner-wrapper').remove();

        dispatchEvent(CHANGE_CONTENT, {});
        return;
    }

    if (block.parents('.ad-popup').length > 0) {
        block.parents('.ad-popup').remove();

        dispatchEvent(CHANGE_CONTENT, {});
        return;
    }

    if (block.parents('#catfish-block').length > 0) {
        block.parents('#catfish-block').remove();

        dispatchEvent(CHANGE_CONTENT, {});
        return;
    }

    block.remove();

    dispatchEvent(CHANGE_CONTENT, {});
};
